import getVersionId from './getVersionId';

export default getVersionId;
